import React from 'react';

function ExtraInvoice() {
	return (
		<div>
			<ol className="breadcrumb hidden-print">
							<li className="breadcrumb-item"><a href="#/">Home</a></li>
							<li className="breadcrumb-item"><a href="#/">Pages</a></li>
							<li className="breadcrumb-item active"></li>
						</ol>
						
						
						<h1 className="page-header hidden-print">Invoice <small>page header description goes here...</small></h1>
						
						
						<div className="invoice mb-5">
							
							<div className="invoice-company d-flex flex-column flex-lg-row">
								<span className="flex-1 mb-2 mb-lg-0">Company Name, Inc</span>
								<span className="d-flex gap-2 hidden-print">
									<a href="#/" className="btn btn-white"><i className="fa fa-file-pdf t-plus-1 text-danger fa-fw fa-lg"></i> Export as PDF</a>
									<a href="#/" onClick={() => window.print()} className="btn btn-white"><i className="fa fa-print t-plus-1 fa-fw fa-lg"></i> Print</a>
								</span>
							</div>
							
							
							<div className="invoice-header">
								<div className="invoice-header-col">
									<div className="fw-semibold text-secondary">from</div>
									<address className="my-1">
										<strong className="text-body fw-bolder fs-5">Twitter, Inc.</strong><br />
										<span>
											Street Address<br />
											City, Zip Code<br />
											Phone: (123) 456-7890<br />
											Fax: (123) 456-7890
										</span>
									</address>
								</div>
								<div className="invoice-header-col">
									<div className="fw-semibold text-secondary">to</div>
									<address className="my-1">
										<strong className="text-body fw-bolder fs-5">Company Name</strong><br />
										<span>
											Street Address<br />
											City, Zip Code<br />
											Phone: (123) 456-7890<br />
											Fax: (123) 456-7890
										</span>
									</address>
								</div>
								<hr className="d-lg-none my-0" />
								<div className="invoice-header-col text-lg-end">
									<div className="fw-semibold text-secondary">Invoice / July period</div>
									<div className="mt-1 fw-bolder fs-5">August 3,2026</div>
									<div className="invoice-detail">
										#0000123DSS<br />
										Services Product
									</div>
								</div>
							</div>
							
							
							<div className="invoice-content">
								
								<div className="table-responsive mb-4">
									<table className="table table-py-12px mb-0 text-nowrap">
										<thead>
											<tr>
												<th className="ps-0">TASK DESCRIPTION</th>
												<th className="text-center" width="10%">RATE</th>
												<th className="text-center" width="10%">HOURS</th>
												<th className="text-end pe-0" width="20%">LINE TOTAL</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className="ps-0">
													<div className="fw-bold">Website design &amp; development</div>
													<div className="text-body text-opacity-75 small">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis arcu.</div>
												</td>
												<td className="text-center">$50.00</td>
												<td className="text-center">50</td>
												<td className="text-end pe-0">$2,500.00</td>
											</tr>
											<tr>
												<td className="ps-0">
													<div className="fw-bold">Branding</div>
													<div className="text-body text-opacity-75 small">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis arcu.</div>
												</td>
												<td className="text-center">$50.00</td>
												<td className="text-center">40</td>
												<td className="text-end pe-0">$2,000.00</td>
											</tr>
											<tr>
												<td className="ps-0">
													<div className="fw-bold">Redesign Service</div>
													<div className="text-body text-opacity-75 small">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis arcu.</div>
												</td>
												<td className="text-center">$50.00</td>
												<td className="text-center">50</td>
												<td className="text-end pe-0">$2,500.00</td>
											</tr>
										</tbody>
									</table>
								</div>
								
								
								<div className="invoice-price">
									<div className="invoice-price-start">
										<div className="invoice-price-row">
											<div className="sub-price">
												<small className="text-body text-opacity-50">SUBTOTAL</small>
												<span className="fw-bolder">$4,500.00</span>
											</div>
											<div className="sub-price">
												<i className="fa fa-plus text-body text-opacity-25"></i>
											</div>
											<div className="sub-price">
												<small className="text-body text-opacity-50">PAYPAL FEE (5.4%)</small>
												<span className="fw-bolder">$108.00</span>
											</div>
										</div>
									</div>
									<div className="invoice-price-end">
										<small className="text-white text-opacity-50">TOTAL</small>
										<span className="fw-bolder">$4508.00</span>
									</div>
								</div>
								
							</div>
							
							
							<div className="invoice-note">
								<p className="mt-lg-5 mt-4 mb-0">
									* Make all cheques payable to [Your Company Name]<br />
									* Payment is due within 30 days<br />
									* If you have any questions concerning this invoice, contact  [Name, Phone Number, Email]
								</p>
							</div>
							
							
							<div className="invoice-footer">
								<p className="text-center my-lg-3 my-2 fw-bold">
									THANK YOU FOR YOUR BUSINESS
								</p>
								<div className="d-flex flex-wrap gap-lg-4 gap-2 align-items-center justify-content-center fw-semibold mb-3">
									<span className="d-flex align-items-center gap-2"><i className="fa fa-fw fa-lg fa-globe opacity-3"></i> matiasgallipoli.com</span>
									<span className="d-flex align-items-center gap-2"><i className="fa fa-fw fa-lg fa-phone-volume opacity-3"></i> T:016-18192302</span>
									<span className="d-flex align-items-center gap-2"><i className="fa fa-fw fa-lg fa-envelope opacity-3"></i> rtiemps@gmail.com</span>
								</div>
							</div>
							
						</div>
		</div>
	);
}

export default ExtraInvoice;
